
(function(){
  var KEY='price_view_v4';
  function getView(){ try{return localStorage.getItem(KEY)||'both';}catch(e){return 'both';} }
  function setView(v){
    try{document.querySelectorAll('[data-price-toggle-btn]').forEach(function(b){ b.setAttribute('aria-pressed', v==='no-ek' ? 'true':'false');});}catch(e){}
 try{localStorage.setItem(KEY,v);}catch(e){} document.documentElement.setAttribute('data-price-view', v); }
  function bindToggle(){
    document.querySelectorAll('[data-price-toggle-btn]').forEach(function(btn){
      btn.addEventListener('click', function(ev){ ev.preventDefault(); setView(getView()==='no-ek'?'both':'no-ek'); });
    });
  }
  function curVid(){
  var f=document.querySelector('form[action*="/cart/add"]');
  if(!f) return null;
  var id=f.querySelector('input[name="id"], select[name="id"]');
  return id? id.value : null;
}
  function parseMap(sel){
    var el=document.querySelector(sel);
    if(!el) return {};
    try{return JSON.parse(el.textContent);}catch(e){return {};}
  }
  function updateDualPrices(){
  var form = document.querySelector('form[action*="/cart/add"]');
  if (!form) { return; }
    var uvpMap=parseMap('script[data-uvp-map]');
    var vid=curVid();
    var uvpText=(vid && uvpMap[vid])? uvpMap[vid] : '-';
    // Update UVP-only blocks
    document.querySelectorAll('[data-price-uvp]').forEach(function(el){
      el.textContent = (uvpText && uvpText.trim()!=='')? uvpText : '-';
    });
    // Mirror native EK into any .price-dual EK spans (e.g., collection cards)
    var native = document.querySelector('[data-price-wrapper] [data-product-price]');
    var ekText = native ? native.textContent.trim() : null;
    if (ekText){
      document.querySelectorAll('.price-dual .price-ek').forEach(function(el){ el.textContent = ekText; });
    }
  }
  function bindVariantObservers(){
    var inputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
    inputs.forEach(function(inp){
      inp.addEventListener('change', updateDualPrices);
      inp.addEventListener('input', updateDualPrices);
      try{ new MutationObserver(function(){ updateDualPrices(); }).observe(inp, {attributes:true, attributeFilter:['value']}); }catch(e){}
    });
    // also option swatches
    document.querySelectorAll('form[action*="/cart/add"] [name^="options"], .product-option input, .product-option select').forEach(function(el){
      el.addEventListener('change', updateDualPrices);
      el.addEventListener('input', updateDualPrices);
    });
    ['variant:change','variant:changed','product:variant:change','product:variant-change','shopify:section:load'].forEach(function(evt){
      document.addEventListener(evt, updateDualPrices, true);
    });
  }
  document.addEventListener('DOMContentLoaded', function(){
    setView(getView());
    bindToggle();
    bindVariantObservers();
    updateDualPrices();
  });
})();
